import getColor from "@insite/mobius/utilities/getColor";
import breakpoint from "@store/Framework/Common/Utilities/breakpoint";
import breakpointValues from "@store/Framework/Common/Utilities/breakpointValues";
import { pxToRemArray } from "@store/Framework/Common/Utilities/unitHelper";
import Styleguide from "@store/Framework/Types/Styleguide";
import Close from "@store/Library/Components/Icons/Close";
import { focusUpdateStyles } from "@store/Themes/common/mixins/common";
import { transitionHoverStyles } from "@store/Themes/common/mixins/transition";
import { buttonResetProps } from "@store/Themes/common/props/button";
import { css } from "styled-components";

const padding = pxToRemArray([20, 26]);

const modal: Styleguide["modal"] = {
    defaultProps: {
        headlineTypographyProps: {
            forwardAs: "p",
            variant: null as any,
        },
        closeButtonProps: {
            ...buttonResetProps,
            css: css`
                ${buttonResetProps.css}
                ${focusUpdateStyles(true)}
                transition: ${transitionHoverStyles("color")};
                flex-shrink: 0;

                ${breakpointValues(
                    padding.map(x => (x ? `calc(${x} / 2) ${x}` : x)),
                    "padding",
                )}

                ${breakpointValues(
                    padding.map(x => (x ? `calc(-${x} / 2) -${x} calc(-${x} / 2) auto` : x)),
                    "margin",
                )}

                &:hover {
                    color: ${getColor("primary")};
                }
            `,
        },
        closeButtonIconProps: {
            src: Close,
            size: 18,
        },
        cssOverrides: {
            modalTitle: css`
                align-items: flex-start;

                ${({ theme }) => css`
                    font-size: ${theme.design.typography.size.large};
                    font-weight: ${theme.design.typography.weight.bold};
                    line-height: ${theme.design.typography.lineHeight.small};

                    ${breakpoint("sm")} {
                        font-size: ${theme.design.typography.size.larger};
                    }
                `}

                ${breakpointValues(
                    padding.map(x => (x ? `calc(${x} / 2) ${x}` : x)),
                    "padding",
                )}
            `,
            modalContent: css`
                ${breakpointValues(padding, "padding")}
            `,
        },
    },
};

export default modal;
